import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CalendarService } from '../services/calender-service';

@Pipe({
  name: 'dataType',
})
export class DataTypePipe implements PipeTransform {
  constructor(
    private translate: TranslateService,
    private calendarService: CalendarService
  ) {}

  transform(value: any, columnName: any, nullAble?: boolean): string {
    if (columnName === 'tamindate') {
      const taminDatePattern: RegExp =
        /^(?<year>\d{4})(?<month>\d{2})(?<day>\d{2})$/;
      const testTaminDatePattern: boolean = taminDatePattern.test(value);
      if (testTaminDatePattern) {
        const groups = value.match(taminDatePattern)?.groups;
        const year: number = Number(groups?.['year']);
        const month: number = Number(groups?.['month']);
        const day: number = Number(groups?.['day']);

        return `${year}/${month}/${day}`;
      }
    }
    if (columnName === 'salamatdate') {
      const taminDatePattern: RegExp =
        /^(?<year>\d{4})\/(?<month>\d{2})\/(?<day>\d{2}).*/;
      const testTaminDatePattern: boolean = taminDatePattern.test(value);
      if (testTaminDatePattern) {
        const groups = value.match(taminDatePattern)?.groups;
        const year: number = Number(groups?.['year']);
        const month: number = Number(groups?.['month']);
        const day: number = Number(groups?.['day']);

        return `${year}/${month}/${day}`;
      }
    }
    if (typeof value === 'string') {
      const onlyDigitsPattern: RegExp = /^\d+$/;
      const containsOnlyDigits: boolean = onlyDigitsPattern.test(value);
      if (containsOnlyDigits) {
        if (
          columnName.toLowerCase().includes('price') ||
          columnName.toLowerCase().includes('amount')
        ) {
          return (
            value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' ریال '
          );
        }

        if (
          columnName.toLowerCase().includes('national') ||
          columnName.toLowerCase().includes('melli')
        ) {
          return value.toString();
        }
        if (columnName.toLowerCase().includes('telephone')) {
          return value.toString().replace(/(\d{3})(\d{4})(\d{4})/g, '$1-$2-$3');
        }
        if (
          columnName.toLowerCase().includes('erx') ||
          columnName.toLowerCase().includes('barcode')
        ) {
          return value.toString();
        }
        if (
          columnName.toLowerCase().includes('gtn') ||
          columnName.toLowerCase().includes('irc')
        ) {
          return value
            .toString()
            .replace(/(\d{4})(\d{4})(\d{1,})/g, '$1-$2-$3');
        }

        if (columnName.toLowerCase().includes('cardnumber')) {
          var thisCulture = this.translate.currentLang;
          if (thisCulture == 'fa') {
            return value
              .toString()
              .replace(/(\d{4})(\d{4})(\d{4})(\d{4})/g, '$4 - $3 - $2 - $1');
          } else {
            return value
              .toString()
              .replace(/(\d{4})(\d{4})(\d{4})(\d{4})/g, '$1 - $2 - $3 - $4');
          }
        }

        return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }

      const regexPattern: RegExp =
        /\d{4}(-|\/)\d{2}(-|\/)\d{2}(T| )\d{2}:\d{2}:\d{2}/;

      const isMatch: boolean = regexPattern.test(value);

      if (isMatch && columnName == 'justDate') {
        const pareDatePattern: RegExp =
          /(?<year>\d{4})(-|\/)(?<month>\d{2})(-|\/)(?<day>\d{2})/;
        const testParseDatePattern: boolean = pareDatePattern.test(value);
        if (testParseDatePattern) {
          const groups = value.match(pareDatePattern)?.groups;
          const year: number = Number(groups?.['year']);
          const month: number = Number(groups?.['month']);
          const day: number = Number(groups?.['day']);

          return `${year}/${month}/${day}`;
        }
      } else if (isMatch) {
        const pareDatePattern: RegExp =
          /(?<year>\d{4})(-|\/)(?<month>\d{2})(-|\/)(?<day>\d{2})/;
        const testParseDatePattern: boolean = pareDatePattern.test(value);
        if (testParseDatePattern) {
          const groups = value.match(pareDatePattern)?.groups;
          const year: number = Number(groups?.['year']);
          const month: number = Number(groups?.['month']);
          const day: number = Number(groups?.['day']);
          if (year>2000) {
            const persianDate = this.calendarService.ToPersianDateTime(value);
            return `${year}/${month}/${day} - ${persianDate.year}/${persianDate.month}/${persianDate.day}`;
          }else{
            return `${year}/${month}/${day}`;
          }
        }
      }

      if (value.length == 0) {
        if (nullAble == false) {
          return '';
        } else {
          return '--';
        }
      }

      return value;
    } else if (typeof value === 'number') {
      if (columnName == 'paidState') {
        if (value == 0) {
          return this.translate.instant('unPaid');
        } else if (value == 100) {
          return this.translate.instant('midPaid');
        } else if (value == 200) {
          return this.translate.instant('completePaid');
        } else {
          return this.translate.instant('undefined');
        }
      }
      if (columnName == 'medicalCouncilCode') {
        return value.toString();
      }
      if (columnName.toLowerCase().includes('telephone')) {
        return value.toString().replace(/(\d{3})(\d{4})(\d{4})/g, '$1 $2 $3');
      }
      if (
        columnName.toLowerCase().includes('price') ||
        columnName.toLowerCase().includes('cost') ||
        columnName.toLowerCase().includes('amount')
      ) {
        return (
          value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' ریال '
        );
      } else {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
    } else if (typeof value === 'boolean') {
      return ``;
    } else {
      if (nullAble == false) {
        return '';
      } else {
        return '--';
      }
    }
  }
}
